<template>

  <v-row class="fill-height" align="center" justify="center" style="margin: 0;">
    <v-carousel v-if="images.length" hide-delimiters cycle>
      <v-carousel-item v-for="(img, i) in images" :key="i">
        <v-sheet height="100%" color="transparent">
          <v-row class="fill-height" align="center" justify="center">

            <v-img :src="img.src" style="border-radius: 8px" contain max-width="94%" max-height="calc(100vh - 21rem)" />

          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>

    <div v-else style="text-align: center;">
      <v-icon x-large @click="$emit('photo')">mdi-camera-outline</v-icon>
    </div>

  </v-row>

</template>

<script>

export default {
  name: "photoCarousel",
  props: {
    images: { type: Array, default: [] },
  },
}
</script>


